<template>
  <b-modal
    id="fillfeedback"
    centered
    hide-footer
    hide-header
    class="p-0"
    size="md"
    no-close-on-backdrop
    @hidden="closeFillFeedback"
  >
    <div class="mb-3">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="modal-head-pan">Give Feedback</span>

        <div @click="closeFillFeedback">
          <img
            src="../../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            class="pointer rotate-on-hover"
          />
        </div>
      </div>
      <hr style="position: absolute; width: 600px; left: -1px" />
    </div>
    <div class="submodal-body py-3 px-2">
      <div class="position-relative" v-if="showRecOptions">
        <SelectCustom
          :mandatory="true"
          :placeholder="'Select'"
          :values="getFilteredRecOptions"
          :dropdown="true"
          @select-value="
            (feedback.recOption = $event),
              (feedback.recommendation =
                thirdPartyData.configuration.recommendationKey[$event])
          "
          :vmodel="$v.feedback.recOption.$model"
          :label="'Recommendation'"
          :showError="$v.feedback.recOption.$error"
        />
        <div v-if="$v.feedback.recOption.$error" class="error-txt-tc">
          Required
        </div>
      </div>
      <div v-else class="mr-2">
        <b-form-group
          class="panlogradio"
          :class="{
            'panlogradio-err':
              $v.feedback.recommendation.$dirty &&
              !$v.feedback.recommendation.required,
          }"
          v-slot="{ ariaDescribedby }"
        >
          <div class="modal-subheads">
            Recommendation<span class="asterik">*</span>
          </div>
          <div
            class="
              fdf-add-container
              mt-2
              w-75
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="S"
              :disabled="viewfeedback"
              >Select</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="viewfeedback"
              value="H"
              >Hold</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="viewfeedback"
              value="R"
              >Reject</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="viewfeedback"
              value="DNA"
              >No Show</b-form-radio
            >
          </div>
        </b-form-group>
      </div>
      <div>
        <div class="mt-3">
          <label class="modal-subheads-pts"
            >Remarks<span class="asterik">*</span></label
          >
          <b-form-textarea
            class="remarks-panlog mt-2"
            type="text"
            rows="3"
            v-model.trim="$v.recruiterRemarks.$model"
            :class="{
              'remarks-panlog-err': $v.recruiterRemarks.$error,
            }"
            placeholder="Enter"
            max-rows="3"
            no-resize
          >
          </b-form-textarea>
          <div v-if="!$v.recruiterRemarks.maxLength" class="error-txt-tc">
            Exceeded the max char length of 256
          </div>
          <div v-else-if="$v.recruiterRemarks.$error" class="error-txt-tc">
            Required
          </div>
        </div>
      </div>
      <hr style="width: 561px" />
      <div class="mt-3 pt-3 pr-2">
        <div class="modal-subheads">Basic Info</div>
        <div class="mt-3 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Candidate Name</span>
          <div class="basic-info-divs px-2 py-2">
            {{ interviewCandidate }}
          </div>
        </div>
        <div class="mt-2 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Evaluation Date</span>
          <div class="basic-info-divs px-2 py-2">{{ evalDate }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Panel Name</span>
          <div class="basic-info-divs px-2 py-2">{{ panelName }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Mode of Interview</span>
          <div class="basic-info-divs px-2 py-2">Face To Face</div>
        </div>
      </div>
      <div
        v-if="
          feedback.recommendation != 'DNA' && feedback.recommendation != 'NI'
        "
        class="mt-3 p-1"
      >
        <div
          class="mt-2 givefdbck-blue-containers"
          :class="{
            error:
              $v.feedbackform.skills.$each[inputindex].mark.$error ||
              $v.feedbackform.skills.$each[inputindex].comments.$error ||
              !$v.feedbackform.skills.$each[inputindex].comments.maxLength ||
              !$v.feedbackform.skills.$each[inputindex].mark.between,
          }"
          v-for="(input, inputindex) in feedbackform.skills"
          :key="inputindex"
        >
          <div>
            <div class="newInt-inner-containers-head mb-2 text-truncate">
              {{ input.name }}
              <span class="asterik" v-if="input.mandatory">*</span>
            </div>

            <div class="d-flex" v-if="input.markingType == 'rating'">
              <div class="mt-2 pt-1 newInt-inner-containers-subhead">
                Rating
              </div>
              <div>
                <b-form-rating
                  variant="primary"
                  v-model="input.mark"
                  class="mb-2 newInt-rating p-0 w-25 ml-2"
                ></b-form-rating>
              </div>
            </div>

            <div v-if="input.markingType == 'score'">
              <div class="topDiv d-flex align-items-center">
                <div>
                  <label class="newInt-inner-containers-subhead">Score</label>
                </div>
                <div class="ml-2">
                  <b-form-input
                    class="p-1 h37-w44 newInt-previewInputField-score"
                    v-model="input.mark"
                    type="number"
                  >
                  </b-form-input>
                </div>
                <div class="ml-2 newInt-preview-container-subFont">
                  out of 10
                  <span
                    v-if="
                      !$v.feedbackform.skills.$each[inputindex].mark.between
                    "
                    class="error-txt-tc ml-2"
                    >Should be between 1 to 10</span
                  >
                </div>
              </div>
            </div>

            <div class="mt-1" v-if="input.commentMode == true">
              <div class="topDiv">
                <div>
                  <label class="newInt-inner-containers-subhead"
                    >Comments</label
                  >
                </div>
                <div class="mt-1">
                  <b-form-textarea
                    class="newInt-previewInputField"
                    v-model="input.comments"
                    placeholder="Enter"
                    rows="3"
                    max-rows="3"
                    no-resize
                  >
                  </b-form-textarea>
                  <div
                    v-if="
                      !$v.feedbackform.skills.$each[inputindex].comments
                        .maxLength
                    "
                    class="error-txt-tc"
                  >
                    Exceeded the max char length of 124
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- {{ feedbackform}} -->
      <div
        class="mt-2 givefdbck-blue-containers ml-1 mr-1"
        v-if="
          feedbackform.screenshot &&
          feedback.recommendation != 'DNA' &&
          feedback.recommendation != 'NI'
        "
      >
        <UploadImage
          :mandatory="true"
          label="Candidate Screenshot"
          placeholder="Select file"
          type="upload_file"
          id="feedback"
          @select-value="previewImage"
          :maxFileSize="fileSize"
          :fileFormat="['jpg', 'jpeg', 'png', 'webp']"
          :showError="showErrorImage"
        />
      </div>
    </div>

    <div
      class="d-flex align-items-center mt-3"
      :class="
        showBotAnalysis ? 'justify-content-between' : 'justify-content-end'
      "
    >
      <div
        v-if="showBotAnalysis"
        @click="goToBotAnalysis"
        class="d-flex pointer pl-2"
      >
        <img alt="" class="mr-2" src="@/assets/img/newkanban/botanalysis.svg" />
        <div class="fdbk-his-link">View Bot Analysis</div>
      </div>
      <div class="d-flex">
        <div class="cancelpan-btn mr-3">
          <b-button class="addbtn h-32 w-87" @click="closeFillFeedback"
            >Cancel</b-button
          >
        </div>
        <div class="addpanellog position-relative">
          <b-button
            class="addbtn h-32 w-87"
            @click="!buttonLoader ? giveFeedBack() : ''"
            :class="buttonLoader ? 'givefeed-loader-class' : 'pointer'"
          >
            <span v-if="!buttonLoader"> Send </span>
          </b-button>

          <div v-if="buttonLoader" class="loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import Loader from "../../../components/fixedcomponents/Loader.vue";
import { getValidations } from "../../panelLogin/validations.js";
import { giveFeedBack } from "../../panelLogin/asynchronous.js";
import { mapGetters } from "vuex";
import toast from "../../../components/mixin/toast";
import UploadImage from "../../../components/InputComponents/UploadImage";
import SelectCustom from "../../../components/InputComponents/SelectCustom";

export default {
  name: "GiveFeedback",
  components: {
    UploadImage,
    Loader,
    SelectCustom,
  },
  props: {
    evalDate: String,
    panelName: String,
    viewfeedback: Boolean,
    feedback: Object,
    interviewResponse: Object,
    feedbackform: Object,
    interviewCandidate: String,
    uploadcandheight: String,
    allpaneldata: Array,
    showfeedbackSpinner: Boolean,
    showGiveFeebackButton: Boolean,
    selectedCandidate: Object,
    interviewObject: Object,
  },
  data() {
    return {
      buttonLoader: false,
      showErrorImage: false,
      fileSize: "5",
      isLaptop: true,
      recruiterRemarks: "",
      showLoader: false,
      screenshotname: null,
      image: null,
      checkMedia: false,
      fileCheck: false,
      checkimage: false,
      isFailed: false,
      feedbackHistory: [],
      viewScreenshot: "",
    };
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  mixins: [toast],

  validations() {
    return getValidations(this);
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters({ roles: "roles" }),
    showBotAnalysis() {
      return (
        this.roles.includes("VIEW_CANDIDATE_ANALYSIS") &&
        this.interviewObject.botInfo?.botAnalysisCompleted
      );
    },
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
    getFilteredRecOptions() {
      if (this.showRecOptions) {
        return Object.entries(
          this.thirdPartyData.configuration.feedbackLevelOptions
        ).map(([key, label]) => {
          return { key, label };
        });
      }
      return [];
    },
  },
  methods: {
    goToBotAnalysis() {
      let queryData = {
        intid: this.interviewObject.interviewID,
        type: 1,
        givefeed: true,
        fromPage: this.$route.name,
        candidateID: this.selectedCandidate.candidateID,
        round: this.selectedCandidate.kanbanLevel,
      };
      queryData = {
        ...queryData,
        ...this.$route.query,
      };
      delete queryData.preview;
      this.$emit("storeCandidateData");
      this.$router.push({
        name: "BotAnalysis",
        query: queryData,
      });
    },
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    removeImage() {
      this.feedbackform.screenshotMedia = "";
      this.imagename = "";
      this.checkimage = false;
    },
    previewImage(data) {
      this.feedbackform.screenshotMedia = data;
    },
    async giveFeedBack() {
      if (this.feedback.recommendation == "DNA") {
        await giveFeedBack(this);
      } else {
        this.$v.$touch();
        try {
          await giveFeedBack(this);

          if (
            !this.$v.feedbackform.skills.$invalid &&
            !this.$v.feedback.recommendation.$invalid
          ) {
            this.$emit("giveLastFdbck");
          }
        } catch (error) {
          console.error("Error in giveFeedBack:", error);
          this.buttonLoader = false;
        }
      }
    },
    closeFillFeedback() {
      this.$v.$reset();
      this.$bvModal.hide("fillfeedback");
      if (this.$route.query.givefeed) {
        let newQuery = { ...this.$route.query };
        delete newQuery.givefeed;
        delete newQuery.round;
        delete newQuery.candidateID;
        delete newQuery.history;
        this.$router.replace({ path: this.$route.path, query: newQuery });
      }
      this.recruiterRemarks = "";
      this.screenshotname = "";
      this.checkimage = false;
      this.isFailed = false;
      this.checkMedia = false;
      this.showErrorImage = false;

      this.$v.recruiterRemarks.$reset();
    },
  },
};
</script>
<style scoped>
input[type="file"] {
  opacity: 0;
}
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 87px;
}
.defaultCursor {
  cursor: default;
}
</style>
